/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { CoreModule } from './@core/core.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from "ng2-file-upload";
import { ClipboardModule } from 'ngx-clipboard';
import { UiSwitchModule } from 'ngx-ui-switch';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from "./auth/guard";
import { PointService } from "./service/service";
import { LoginComponent } from "./auth/login/login";
import { LogoutComponent } from "./auth/logout/logout";
import { UploaderComponent } from './helpers/file-uploader/file-upload.component';
import { SharedModule } from './helpers/shared/shared.module';
import { FileUploaderModule } from './helpers/file-uploader/file-upload.module';
import { Utils } from "./helpers/utils";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PapaParseModule } from 'ngx-papaparse';


@NgModule({
  declarations: [AppComponent, LoginComponent, LogoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    HttpModule,
    NgSelectModule,
    FormsModule,
    FileUploadModule,
    ClipboardModule,
    DragDropModule,
    SharedModule,
    FileUploaderModule,
    PapaParseModule,
    UiSwitchModule
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    AuthGuard,
    PointService,
    HttpClientModule,
    HttpModule,
    FileUploadModule,
    Utils
  ],
  exports: [],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
}
